import { ColumnPattern } from '@/common/components/Table'

export const missionsColumns: ColumnPattern[] = [
  { label: 'Estabelecimento', value: 'establishment' },
  { label: 'Status', value: 'status', className: 'w-[120px]' },
  { label: 'Nome', value: 'name' },
  { label: 'Início', value: 'start_date' },
  { label: 'Fim', value: 'end_date' },
  { label: 'Ações', value: 'actions', className: 'w-[60px]' },
]
